import React, { useState } from 'react';
import '../css/dataTable.css';
import { adminUsers } from '../Data/adminUser.js';
import { useTable } from "../hooks/useTable";
import { FaFileCsv, FaFilePdf, FaFileExcel } from 'react-icons/fa';
import { exportToCSV, exportToPDF, exportToExcel } from '../../utils/exportUtils.js';


function AdminTable() {
    const [searchTerm, setSearchTerm] = useState("");
    const itemsPerPage = 5;
    
    const { currentItems, filteredData, currentPage, paginate } = useTable(
        adminUsers,
        itemsPerPage,
        searchTerm
      );

    // Définir les en-têtes pour le PDF
    const headers = ['Nom complet', 'Adresse', 'Email', 'Téléphone', 'Role', 'Permissions', 'Statut'];

    const handleAddAdmin = () => {
        alert("ok");
    };

  return (
    <div className="container">
    {/* En-tête avec titre et barre de recherche */}
    <div className="header-container">
      <h2 className="table-title">Liste des administrateurs</h2>
      <input
        type="text"
        placeholder="Rechercher un administrateur..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="search-bar"
      />
    </div>

    {/* Boutons d'exportation */}
    <div className="export-buttons-container">
                <button onClick={() => exportToCSV(filteredData, 'admin_users')} className="export-button">
                    <FaFileCsv className="icon" /> Export CSV
                </button>
                <button onClick={() => exportToPDF(filteredData, headers, 'admin_users')} className="export-button">
                    <FaFilePdf className="icon" /> Export PDF
                </button>
                <button onClick={() => exportToExcel(filteredData, 'admin_users')} className="export-button">
                    <FaFileExcel className="icon" /> Export Excel
                </button>
                <button onClick={handleAddAdmin} className="add-admin-button">
                    Ajouter un Admin
                </button>
            </div>

    {/* Tableau */}
    <table className="abonne-table">
      <thead>
        <tr>
          <th>Nom complet</th>
          <th>Adresse</th>
          <th>Email</th>
          <th>telephone</th>
          <th>Role</th>
          <th>Permissions</th>
          <th>Statut</th>
        </tr>
      </thead>
      <tbody>
        {currentItems.map((user) => (
          <tr key={user.id}>
                <td>{user.nomComplet}</td>
                <td>{user.adresse}</td>
                <td>{user.email}</td>
                <td>{user.telephone}</td>
                <td>{user.role}</td>
                <td>{user.permissions}</td>
                <td>{user.Etat}</td>
            </tr>
        ))}
      </tbody>
    </table>

    {/* Pagination */}
    <div className="pagination">
      {Array.from(
        { length: Math.ceil(filteredData.length / itemsPerPage) },
        (_, i) => (
          <button
            key={i + 1}
            onClick={() => paginate(i + 1)}
            className={currentPage === i + 1 ? "active" : ""}
          >
            {i + 1}
          </button>
        )
      )}
    </div>
  </div>
  )
}

export default AdminTable